export class GuestIdentityReissuedError extends Error {
    constructor(uberToken) {
        super('New Guest Identity reissued');
        this.uberToken = uberToken;
        this.code = '_ERR_GUEST_IDENTITY_REISSUED';
    }
}
